

export const CommonPageState =  Object.freeze({
  ListWithItems:  Symbol("list_with_items"),
  EditItem: Symbol("edit_item"),
  CreateItem: Symbol("create_item"),
});